import { render } from "./AppDocument.vue?vue&type=template&id=81c1217e&scoped=true"
import script from "./AppDocument.vue?vue&type=script&lang=js"
export * from "./AppDocument.vue?vue&type=script&lang=js"

import "./AppDocument.vue?vue&type=style&index=0&id=81c1217e&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Tomi\\PhpstormProjects\\frontend-v2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81c1217e"]])

export default __exports__